export type SupabaseEnvSource = Readonly<Record<string, string | undefined>>;

export interface PublicSupabaseEnv {
  url: string;
  publishableKey: string;
}

export interface ServerSupabaseEnv {
  url: string;
  projectRef: string;
  secretKey: string;
}

const PUBLIC_SECRET_NAME = /(?:SECRET|SERVICE_ROLE|PRIVATE)/i;

export class SupabaseEnvError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SupabaseEnvError';
  }
}

function requireEnv(source: SupabaseEnvSource, name: string): string {
  const value = source[name]?.trim();

  if (!value) {
    throw new SupabaseEnvError(`Variável obrigatória ausente: ${name}`);
  }

  return value;
}

export function readPublicSupabaseEnv(source: SupabaseEnvSource): PublicSupabaseEnv {
  const exposedSecret = Object.keys(source).find(
    (name) => name.startsWith('VITE_') && PUBLIC_SECRET_NAME.test(name),
  );

  if (exposedSecret) {
    throw new SupabaseEnvError(`Variável de cliente não pode anunciar segredo: ${exposedSecret}`);
  }

  return {
    url: requireEnv(source, 'VITE_SUPABASE_URL'),
    publishableKey: requireEnv(source, 'VITE_SUPABASE_PUBLISHABLE_KEY'),
  };
}

export function readServerSupabaseEnv(source: SupabaseEnvSource): ServerSupabaseEnv {
  return {
    url: requireEnv(source, 'SUPABASE_URL'),
    projectRef: requireEnv(source, 'SUPABASE_PROJECT_REF'),
    secretKey: requireEnv(source, 'SUPABASE_SECRET_KEY'),
  };
}
